const setPageTitle = (title) => {
    if (title) {
      document.title = title + ' - Loading.se';
    } else {
      document.title = 'Loading.se';
    }
}

export default setPageTitle;


/*
ToDo:
If you have unread/new citeringar, then add (X) in the beginnig. 
	(2) Loading.se
	(2) The Bullshit Lounge - 5 - Loading.se
*/
